/* eslint-disable react-hooks/exhaustive-deps */
// @ts-ignore - CSS imports are handled by the project build tooling, not TS declarations.
import './SettingsCounselor.css';
// @ts-ignore - CSS imports are handled by the project build tooling, not TS declarations.
import './SettingsParent.css';
import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import toast from 'react-hot-toast';
import { Button, Spinner } from 'react-bootstrap';
import { Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import MuiButton from '@mui/material/Button';
import { scrollToObject } from 'components/helper/ui_helper';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import TextIconInput from 'components/input/TextIconInput';
import PersonOutlinedIcon from 'components/icons/PersonOutlinedIcon';
import CounselorInviteAlertDialog from 'screen/education/highSchool/components/CounselorInviteAlertDialog';
import { INVITATION_STATUS, STRIPE_PRICE_NAME, USER_ROLE } from 'constants/common';
import {
  isInviteListRowConnected,
  isStudentInviteActionPending,
  // normalizeInviteBy,
} from 'utils/invitePartnerList';
import { catName, toTitleCase } from 'components/helper/helper';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { useHistory, useLocation } from 'react-router-dom';
import { routers } from 'router/router';
import partnerServices from 'services/partnerServices';
import { getCurrentBasicDetail, logout } from 'app/basicInformationSlice/basicInformationSlice';
import { getHighSchool } from 'app/highSchoolSlice/highSchoolSlice';
import basicInformationServices from 'services/basicInformationApi';
import { getAccessToken, getUserId, removeAccessToken, removeUserId } from 'utils/sessionStorage';
import { store } from 'app/store';
import { ChatBoxManagerContext } from 'components/ChatBoxManager';
import { useChatList } from 'components/layout/ChatListContext';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ScheduleIcon from '@mui/icons-material/Schedule';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import RefreshIcon from '@mui/icons-material/Refresh';
import CheckIcon from '@mui/icons-material/Check';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import ChatBubbleOutline from '@mui/icons-material/ChatBubbleOutline';
// import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
// import CheckBoxOutlined from '@mui/icons-material/CheckBoxOutlined';
// import HistoryOutlined from '@mui/icons-material/HistoryOutlined';
// import ArrowUpward from '@mui/icons-material/ArrowUpward';
// import ArrowDownward from '@mui/icons-material/ArrowDownward';
// import { authenticateSettings } from 'components/helper/appConfig';
// import Cookies from 'js-cookie';

interface Props {}

const RELATIONSHIP_OPTIONS = [
  { value: '', label: 'Select...' },
  { value: 'Mother', label: 'Mother' },
  { value: 'Father', label: 'Father' },
  { value: 'Guardian', label: 'Guardian' },
  { value: 'Tutor', label: 'Tutor' },
  { value: 'Stepparent', label: 'Stepparent' },
  { value: 'Other', label: 'Other' },
];

function formatRelationshipLabel(raw: string | undefined) {
  if (!raw || !String(raw).trim()) return 'Parent / Guardian';
  return toTitleCase(String(raw).replace(/_/g, ' '));
}

/** Shown next to name; when relation is missing, show "Parent" (not "Parent / Guardian"). */
function relationLabelOrParent(raw: string | undefined | null) {
  if (raw == null || !String(raw).trim()) return 'Parent';
  return formatRelationshipLabel(String(raw));
}

function parentVisibilityCopy(sub: { subcription_plan?: string } | null | undefined) {
  const plan = sub?.subcription_plan;
  const silverGold =
    plan === STRIPE_PRICE_NAME.SilverMonth ||
    plan === STRIPE_PRICE_NAME.SilverYear ||
    plan === STRIPE_PRICE_NAME.SilverPlusMonth ||
    plan === STRIPE_PRICE_NAME.SilverPlusYear ||
    plan === STRIPE_PRICE_NAME.GoldMonth ||
    plan === STRIPE_PRICE_NAME.GoldYear;
  if (silverGold) {
    return {
      title: 'WHAT THEY CAN SEE',
      body: 'They can view your profile based on your current plan and permissions.',
      foot: '',
    };
  }
  return {
    title: 'WHAT THEY CAN SEE',
    body: 'Cannot see your profile yet — upgrade to Silver or Gold to give them full access.',
    foot: 'No active plan — upgrade to Silver or Gold for full access',
  };
}

const SettingsParent = (props: Props) => {
  let token = getAccessToken();
  const dispatch:any = useAppDispatch();
  const location = useLocation();
  const history = useHistory();
  const [waiting, setWaiting] = React.useState(false);
  const [currentRow, setCurrentRow] = React.useState<any>();
  const [pendingListAction, setPendingListAction] = React.useState<'approve' | 'decline' | null>(null);
  const [showSession, setShowSession] = React.useState(3);
  const [userRole, setUserRole] = React.useState('');
  // const [highSchoolInfo, setHighSchoolInfo] = React.useState<any>();
  const [currentParent, setCurrentParent] = React.useState<any>();
  const [partnerList, setPartnerList] = React.useState<any[]>([]);
  /** Pending email invites from GET /api/partner/get-my-outgoing-partner-email-invites */
  const [outgoingEmailInvites, setOutgoingEmailInvites] = React.useState<any[]>([]);
  // const [refershList, setRefershList] = React.useState(true);
  const [showAlert, setShowAlert] = React.useState(false);
  const [cancelInviteOpen, setCancelInviteOpen] = React.useState(false);
  const [cancelInviteRow, setCancelInviteRow] = React.useState<any>(null);
  const [removeAccessOpen, setRemoveAccessOpen] = React.useState(false);
  const [removeAccessRow, setRemoveAccessRow] = React.useState<any>(null);
  const [resendErrorOpen, setResendErrorOpen] = React.useState(false);
  const [resendErrorMessage, setResendErrorMessage] = React.useState('');
  const [inviteParentNamesLocked, setInviteParentNamesLocked] = React.useState(false);
  const [inviteParentEmailChecking, setInviteParentEmailChecking] = React.useState(false);
  /** Initial fetch of parents / invites / outgoing list (student Parents tab) */
  const [parentSettingsLoading, setParentSettingsLoading] = React.useState(true);
  const [copiedRowKey, setCopiedRowKey] = React.useState<string | null>(null);

  const isInviteEmailAlreadyListed = React.useCallback(
    (email: string | undefined) => {
      const e = (email ?? '').trim().toLowerCase();
      if (!e) return false;
      if (partnerList.some((p: any) => (p.email ?? '').trim().toLowerCase() === e)) return true;
      if (currentParent?.email && (currentParent.email ?? '').trim().toLowerCase() === e) return true;
      if (
        outgoingEmailInvites.some(
          (inv: any) => (inv.invitee_email ?? '').trim().toLowerCase() === e
        )
      ) {
        return true;
      }
      return false;
    },
    [partnerList, currentParent, outgoingEmailInvites]
  );
  let personalStore = useAppSelector((store) => store.basicInformation.myBasicInformation);
  const subscriptionInfo = useAppSelector((store) => store.basicInformation.stripeSubscriptionInfo);
  const chatBox = React.useContext(ChatBoxManagerContext);
  const { refreshChatList } = useChatList();
  const [relationshipForRequest, setRelationshipForRequest] = React.useState<Record<string, string>>({});
  const role: string = personalStore?.user_role ?? sessionStorage.getItem('userRole') ?? '';
  const showStudentParentsSettings =
    role === USER_ROLE.student || userRole === USER_ROLE.student;

  const studentId = personalStore?.student_id ?? getUserId();
  const hash = location.hash.slice(1); // Remove the '#' character from the hash
  var bInviteParent:boolean = (hash === 'invite_parent');

  // current parent formik
  const currentformik = useFormik({
    initialValues: {
      parent_first_name: '',
      parent_last_name: '',
      parent_role: USER_ROLE.parent,
      parent_email: '',
    },
    validationSchema: Yup.object({
      parent_first_name: Yup.string(),
      parent_last_name: Yup.string(),
      parent_email: Yup.string().email('Invalid email').required('Required'),
    }),
    onSubmit: async (values) => {
      setWaiting(true);

      try {
        const partnerId =
          currentParent?.student_id ?? currentParent?.id ?? currentParent?.partner_id;
        if (partnerId == null || partnerId === '') {
          toast.error('Missing parent account id.');
          setWaiting(false);
          return;
        }
        await partnerServices.updatePartnerInviteStatus(
          studentId,
          partnerId,
          INVITATION_STATUS.withdrawn
        );

        currentformik.setErrors({});
        toast.success('The Parent had been removed successfully.');
        bInviteParent = false;
        setShowAlert(false);
        gotoSettingParent(); // force remmove #tag
        window.location.reload();
      } catch (ex) {
        const err = {
          parent_first_name: '',
          parent_last_name: '',
          parent_role: '',
          parent_email: `${ex}`,
        };

        currentformik.setErrors(err);
      }
      setWaiting(false);
    },
  });

  // new parent formkik
  const formik = useFormik({
    initialValues: {
      parent_first_name: '',
      parent_last_name: '',
      parent_role: USER_ROLE.parent,
      parent_email: '',
    },
    validationSchema: Yup.object({
      parent_first_name: Yup.string(),
      parent_last_name: Yup.string(),
      parent_email: Yup.string().email('Invalid email').required('Required'),
    }),
    onSubmit: async (values) => {
      token = getAccessToken();
      if (token && studentId) {
        setWaiting(true);
        try {
          await partnerServices
            .student_inviteParent(studentId, formik.values.parent_email)
            .then(async (res) => {
              let obj = res.result;
              console.log('student_inviteParent() res: ', res);
              if (obj) {
                formik.setErrors({});
                toast.success(`Your parent has been invited.`);
                setWaiting(false);

                setTimeout(() => {
                  // setRefershList(true);
                  loadCurrentParent();
                  loadParentList();
                  loadOutgoingInvites();
                  refreshChatList();
                  setShowSession(1);
                }, 1500);
              
              }
              else {
                setTimeout(() => {            
                  bInviteParent = false;
                  setShowAlert(false);
                  gotoSettingParent(); // force remmove #tag
                  getDetail();
                  refreshChatList();
                  ///window.location.reload();
                }, 1500);
               }

            });
        } 
        catch (error:any) {
          // The default error.message is just "Request failed with status code 400"
          let strError:string = error.message;
          //console.log("Generic Error Message:", error.message); 
      
          // Check if the error object has a 'response' property (which means the server sent a response)
          if (error.response) {
            // Access the specific data provided by your server's HttpException
            const serverData = error.response.data;
      
            //console.log("Server Status Code:", serverData.statusCode);   // e.g., 400
            //console.log("Detailed Message:", serverData.message);        // e.g., "The parent was invited."
            //console.log("Custom Result Data:", serverData.result);       // e.g., <value of result>
            strError = serverData.message || "An expected error occurred"

            
          } else if (error.request) {
            // The request was made but no response was received (e.g., network down/CORS issues)
            //console.log("No response received from server.");
            strError = "Network Error: Server did not respond.";
      
          } else {
            // Something else happened in setting up the request
            //console.log('Error during request setup:', error.message);
            strError = "An unexpected client error occurred.";
          }

          const err = {
            parent_first_name: '',
            parent_last_name: '',
            parent_role: '',
            parent_email: `${strError}`,            
          };
          formik.setErrors(err);
        }

        setWaiting(false);
      }
      else {
        handleLogout();
      }
    },
  });

  // parent invite student => to become Parent role
  const inviteformik = useFormik({
    initialValues: {
      parent_email: '',
      parent_first_name: '',
      parent_last_name: '',
      relationship: '',
    },
    validationSchema: Yup.object({
      parent_email: Yup.string().email('Invalid email').required('Required'),
      parent_first_name: Yup.string(),
      parent_last_name: Yup.string(),
      relationship: Yup.string(),
    }),
    onSubmit: async (values) => {
      token = getAccessToken();
      if (token && studentId) {
        setWaiting(true);
        try {
          await dispatch(getCurrentBasicDetail(studentId)).unwrap();
          const emailTrim = values.parent_email?.trim() ?? '';
          if (isInviteEmailAlreadyListed(emailTrim)) {
            setWaiting(false);
            return;
          }
          let parentObj:any = await partnerServices.getPartnerByEmail(emailTrim);

          if (parentObj && parentObj.user_role === USER_ROLE.parent) {
            const rel = (values.relationship ?? '').trim();
            await partnerServices.student_inviteParent(
              studentId,
              emailTrim,
              undefined,
              undefined,
              rel || undefined
            );
            inviteformik.setErrors({});
            inviteformik.resetForm();
            setInviteParentNamesLocked(false);
            setWaiting(false);
            toast.success('Your parent has been invited.');
            getDetail();
            refreshChatList();
          } else {
            const fn = values.parent_first_name?.trim() ?? '';
            const ln = values.parent_last_name?.trim() ?? '';
            if (!fn || !ln) {
              inviteformik.setErrors({
                parent_email: '',
                parent_first_name: !fn ? 'Required' : '',
                parent_last_name: !ln ? 'Required' : '',
              });
              setWaiting(false);
              return;
            }
            const rel = (values.relationship ?? '').trim();
            const res = await partnerServices.student_inviteParent(
              studentId,
              emailTrim,
              fn,
              ln,
              rel || undefined
            );
            let obj = res.result;
            console.log('student_inviteParent() res: ', res);
            if (obj) {
              inviteformik.setErrors({});
              toast.success('Your parent has been invited.');
              inviteformik.resetForm();
              setInviteParentNamesLocked(false);
              setTimeout(() => {
                // setRefershList(true);
                loadCurrentParent();
                loadParentList();
                getDetail();
                refreshChatList();
              }, 1500);
            } else {
              setTimeout(() => {
                getDetail();
                refreshChatList();
              }, 1500);
            }
            setWaiting(false);
          }
        } 
        catch (error:any) {
          // The default error.message is just "Request failed with status code 400"
          let strError:string = error.message;
          //console.log("Generic Error Message:", error.message); 
      
          // Check if the error object has a 'response' property (which means the server sent a response)
          if (error.response) {
            // Access the specific data provided by your server's HttpException
            const serverData = error.response.data;
            strError = serverData.message || "An expected error occurred"

            
          } else if (error.request) {
            // The request was made but no response was received (e.g., network down/CORS issues)
            //console.log("No response received from server.");
            strError = "Network Error: Server did not respond.";
      
          } else {
            // Something else happened in setting up the request
            //console.log('Error during request setup:', error.message);
            strError = "An unexpected client error occurred.";
          }

          const err = {
            parent_email: `${strError}`,
            parent_first_name: '',
            parent_last_name: '',
          };
          inviteformik.setErrors(err);
        }

        setWaiting(false);
      }
      else {
        handleLogout();
      }
    },
  });

  const handleInviteParentEmailBlur = async () => {
    const raw = inviteformik.values.parent_email?.trim() ?? '';
    inviteformik.setFieldTouched('parent_email', true);
    if (!raw) {
      if (inviteParentNamesLocked) {
        inviteformik.setFieldValue('parent_first_name', '');
        inviteformik.setFieldValue('parent_last_name', '');
      }
      setInviteParentNamesLocked(false);
      return;
    }
    const basicEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!basicEmail.test(raw)) {
      setInviteParentNamesLocked(false);
      return;
    }
    if (isInviteEmailAlreadyListed(raw)) {
      if (inviteParentNamesLocked) {
        inviteformik.setFieldValue('parent_first_name', '');
        inviteformik.setFieldValue('parent_last_name', '');
      }
      setInviteParentNamesLocked(false);
      inviteformik.setFieldError('parent_email', undefined);
      return;
    }
    try {
      setInviteParentEmailChecking(true);
      const parentObj: any = await partnerServices.getPartnerByEmail(raw);
      if (parentObj && parentObj.user_role === USER_ROLE.parent) {
        inviteformik.setFieldValue('parent_first_name', parentObj.first_name ?? '');
        inviteformik.setFieldValue('parent_last_name', parentObj.last_name ?? '');
        setInviteParentNamesLocked(true);
        inviteformik.setFieldError('parent_email', undefined);
      } else {
        setInviteParentNamesLocked(false);
        inviteformik.setFieldError('parent_email', undefined);
      }
    } catch {
      setInviteParentNamesLocked(false);
    } finally {
      setInviteParentEmailChecking(false);
    }
  };

  const loadCurrentParent = async () => {
    try {
      let student_id = Number(studentId);
      if (!Number.isNaN(student_id)) {        
        const res:any = await basicInformationServices.getCurrentParent(student_id);
        //console.log('getCurrentParent() ~ res:', res);
        if (res) {
          if (res?.statusCode === 200) {
            if (res?.result) {
              let obj:any = res.result;
              currentformik.setValues({
                parent_first_name: obj.first_name,
                parent_last_name: obj.last_name,
                parent_role: obj.user_role,
                parent_email: obj.email,
              });
              setCurrentParent(res.result);
              setShowSession(1);
              if (bInviteParent) {
                setShowAlert(true);
              }
              else {
                setShowAlert(false);
              }
            }
            else {
              setShowSession(2);
            }
          }
          if (res?.statusCode === 404 && res?.result === null) {
            // e.g. { message: "Student has no parents" } — normal empty state, no error toast
            setCurrentParent(undefined);
            currentformik.setValues({
              parent_first_name: '',
              parent_last_name: '',
              parent_role: USER_ROLE.parent,
              parent_email: '',
            });
            setShowSession(2);
          }
        }
      }

    } 
    catch (ex) {
      console.log('Error: ', ex);
    }
  };

  const isStudentViewRemoved = (row: any) =>
    row?.requested_status === INVITATION_STATUS.removed;

  /** API returns only pending + approved; keep for defensive filtering. */
  const isStudentParentInviteRowActive = (r: any) => {
    if (isStudentViewRemoved(r)) return false;
    const s = r?.requested_status;
    return s === INVITATION_STATUS.approved || s === INVITATION_STATUS.pending;
  };

  const loadParentList = async () => {
    if (!studentId) return;
    try {
      const res = await partnerServices.studentGetInvitePartnerList(studentId);
      if (res && res.length > 0) {
        const arr = res.filter((r: any) => isStudentParentInviteRowActive(r));
        const mockData = arr.map((item: any) => ({
          ...item,
          processState: 'No Process',
          chat: Math.floor(Math.random() * 5),
          notes: Math.floor(Math.random() * 6),
          todos: Math.floor(Math.random() * 4),
          lastActivity: 'No activity',
        }));
        setPartnerList(mockData);
      } else {
        setPartnerList([]);
      }
    } catch {
      setPartnerList([]);
    }
  };

  const loadOutgoingInvites = React.useCallback(async () => {
    if (!studentId) return;
    const r = personalStore?.user_role ?? sessionStorage.getItem('userRole');
    if (r !== USER_ROLE.student) return;
    try {
      const data = await partnerServices.getMyOutgoingPartnerEmailInvites();
      const raw = data?.invites ?? (data as any)?.result?.invites ?? [];
      const list = Array.isArray(raw) ? raw : [];
      setOutgoingEmailInvites(list.filter((i: any) => i.consumed_at == null));
    } catch {
      setOutgoingEmailInvites([]);
    }
  }, [studentId, personalStore?.user_role]);

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const getDetail = async () => {
    token = getAccessToken();
    if (!token || !studentId) {
      setParentSettingsLoading(false);
      handleLogout();
      return;
    }
    setParentSettingsLoading(true);
    try {
      const res = await dispatch(getHighSchool(studentId)).unwrap();
      if (res) {
        if (bInviteParent) {
          formik.setFieldValue('parent_first_name', res?.counselor_first_name ?? '');
          formik.setFieldValue('parent_last_name', res?.counselor_last_name ?? '');
          formik.setFieldValue('parent_email', res?.counselor_email ?? '');
        }
      }
      // setHighSchoolInfo(res);
      setShowSession(2);
      const resolvedRole =
        store.getState().basicInformation.myBasicInformation?.user_role ??
        sessionStorage.getItem('userRole') ??
        role ??
        '';
      if (resolvedRole) {
        setUserRole(resolvedRole);
        if (resolvedRole === USER_ROLE.student) {
          setShowSession(2);
          if (studentId) {
            await loadParentList();
            await loadCurrentParent();
            await loadOutgoingInvites();
          }
        }
      }

      if (bInviteParent) {
        scrollToObject('go-to-bottom', 0);
      }
    } catch (e) {
      console.log('getDetail error:', e);
    } finally {
      setParentSettingsLoading(false);
    }
  };

  React.useEffect(() => {
    getDetail();
  }, []);

  // const handleAddNew = function () {
  //   setShowSession(2);
  // };

  const gotoSettingParent = () => {
    try {
        let path = `${routers.settings.path}?active-tab=6`;
        history.push(path);
      }
      catch(ex){
        console.log('Error: ', ex);
      }
  }   


  /** Invite email flow: backend resolves link via token; no separate update-* call. */
  const getPartnerEmailInviteTokenForApi = (item: any): string | null => {
    const raw = item?.partner_email_invite_token_hash ?? item?.partnerEmailInviteTokenHash;
    if (raw == null || String(raw).trim() === '') return null;
    return String(raw).trim();
  };

  const isStudentRoleForPartnerInvite = () =>
    personalStore?.user_role === USER_ROLE.student ||
    userRole === USER_ROLE.student ||
    sessionStorage.getItem('userRole') === USER_ROLE.student;

  /**
   * When invite_token is present, only make-token-used is called (returns true).
   * Otherwise returns false so caller runs updatePartnerInviteStatus.
   */
  const markPartnerEmailInviteTokenUsedIfPresent = async (
    item: any,
    status:
      | typeof INVITATION_STATUS.approved
      | typeof INVITATION_STATUS.declined
      | typeof INVITATION_STATUS.removed
  ): Promise<boolean> => {
    if (!isStudentRoleForPartnerInvite()) return false;
    const invite_token = getPartnerEmailInviteTokenForApi(item);
    if (!invite_token) return false;
    await partnerServices.makeTokenUsed({ invite_token, status });
    return true;
  };

  const handleStudentApproval = async (item: any) => {
    //console.log('handleStudentApproval() item:', item);
    if (item && isStudentInviteActionPending(item)) {
      let student_id = Number(studentId);
      let parentEmail:string = item?.email;
      const viaInviteToken = !!getPartnerEmailInviteTokenForApi(item);

      if (!Number.isNaN(student_id) && (viaInviteToken || parentEmail)) {
        setWaiting(true);
        setCurrentRow(item);
        setPendingListAction('approve');
        try {
          const usedInviteToken = await markPartnerEmailInviteTokenUsedIfPresent(
            item,
            INVITATION_STATUS.approved
          );
          if (!usedInviteToken) {
            const parentPartnerId = item?.student_id ?? item?.partner_id ?? item?.id;
            if (parentPartnerId == null || parentPartnerId === '') {
              toast.error('Missing parent account id.');
              return;
            }
            await partnerServices.updatePartnerInviteStatus(
              student_id,
              parentPartnerId,
              INVITATION_STATUS.approved
            );
          }
          // await partnerServices.sync(parentEmail);
          await loadCurrentParent();
          await loadParentList();
          await loadOutgoingInvites();
          refreshChatList();
          toast.success('Invitation approved successfully.');
        } catch (ex: any) {
          toast.error(ex?.response?.data?.message ?? 'Failed to approve invitation.');
        } finally {
          setWaiting(false);
          setPendingListAction(null);
        }
      }
      else {
        toast.error('parent_email is null');
        console.log('Error: parent_email is null');
      }
    }
  };

  const handleStudentDecline = async (item: any) => {
    if (item && isStudentInviteActionPending(item)) {
      const student_id = Number(studentId);
      const parentEmail: string = item?.email;
      const viaInviteToken = !!getPartnerEmailInviteTokenForApi(item);

      if (!Number.isNaN(student_id) && (viaInviteToken || parentEmail)) {
        setWaiting(true);
        setCurrentRow(item);
        setPendingListAction('decline');
        try {
          const usedInviteToken = await markPartnerEmailInviteTokenUsedIfPresent(
            item,
            INVITATION_STATUS.declined
          );
          if (!usedInviteToken) {
            const parentPartnerId = item?.student_id ?? item?.partner_id ?? item?.id;
            if (parentPartnerId == null || parentPartnerId === '') {
              toast.error('Missing parent account id.');
              return;
            }
            await partnerServices.updatePartnerInviteStatus(
              student_id,
              parentPartnerId,
              INVITATION_STATUS.declined
            );
          }
          // await partnerServices.sync(parentEmail);
          await loadCurrentParent();
          await loadParentList();
          await loadOutgoingInvites();
          refreshChatList();
          toast.success('Invitation declined successfully.');
        } catch (ex: any) {
          toast.error(ex?.response?.data?.message ?? 'Failed to decline invitation.');
        } finally {
          setWaiting(false);
          setPendingListAction(null);
        }
      } else {
        toast.error('parent_email is null');
      }
    }
  };

  const openRemoveAccessDialog = (row: any) => {
    setRemoveAccessRow(row);
    setRemoveAccessOpen(true);
  };

  const closeRemoveAccessDialog = () => {
    if (waiting) return;
    setRemoveAccessOpen(false);
    setRemoveAccessRow(null);
  };

  const confirmRemoveAccess = async () => {
    const item = removeAccessRow;
    if (!item || !isInviteListRowConnected(item)) {
      closeRemoveAccessDialog();
      return;
    }
    setWaiting(true);
    setCurrentRow(item);
    const student_id = Number(studentId);
    try {
      if (!Number.isNaN(Number(student_id))) {
        const parentPartnerId = item?.student_id ?? item?.partner_id ?? item?.id;
        if (parentPartnerId == null || parentPartnerId === '') {
          toast.error('Missing parent account id.');
        } else {
          await partnerServices.updatePartnerInviteStatus(
            student_id,
            parentPartnerId,
            INVITATION_STATUS.removed
          );
          // await partnerServices.sync(item?.email);
          refreshChatList();
          const removedEmail = (item?.email ?? '').trim().toLowerCase();
          const removedParentId = item?.student_id;
          setPartnerList((prev) =>
            prev.filter((p: any) => {
              const sameEmail = (p.email ?? '').trim().toLowerCase() === removedEmail;
              const sameParent =
                removedParentId != null && p.student_id != null && p.student_id === removedParentId;
              return !(sameEmail || sameParent);
            })
          );
          toast.success('Remove the Parent invitaion successfull');
          setRemoveAccessOpen(false);
          setRemoveAccessRow(null);
          await loadCurrentParent();
          await loadParentList();
          await loadOutgoingInvites();
        }
      }
    } catch (ex: any) {
      toast.error(ex?.response?.data?.message ?? 'Could not remove access.');
    } finally {
      setWaiting(false);
    }
  };


  const handleDefaultParent = async (item: any) => {
    //console.log('handleDefaultParent() item:', item);
    let student_id = Number(studentId);
    let parent_id = item.student_id;
    if (!Number.isNaN(student_id)) {
      try {
        setWaiting(true);
        setCurrentRow(item);       
        await partnerServices.setDefaultParent(student_id, parent_id);
        setWaiting(false);
        toast.success('Successfully set current parent for student')
        // reload data
        setTimeout(async () => {
          await loadCurrentParent();
          await loadParentList();
          await loadOutgoingInvites();
          refreshChatList();
        }, 1500);


      }
      catch(ex:any){
        setWaiting(false);
        console.log('Error:', ex);
        toast.error('Internal Error: Can not set default parent');
      }

    }
    else {
        console.log('Error: parent_email is null');
    }      
  };

  const partnerRowKey = (row: any) => String(row?.id ?? `${row?.student_id}-${row?.email ?? ''}`);

  const outgoingInviteRowKey = (row: any) =>
    String(row?.id ?? row?.invitee_email ?? 'invite');

  const connectionRequestRows = React.useMemo(
    () =>
      partnerList
        .filter((r) => isStudentInviteActionPending(r))
        .map((r) => ({
          ...r,
          partner_email_invite_token_hash:
            r.partner_email_invite_token_hash ?? r.partnerEmailInviteTokenHash ?? null,
        })),
    [partnerList]
  );

  const connectedRows = React.useMemo(
    () => partnerList.filter((r) => isInviteListRowConnected(r)),
    [partnerList]
  );

  const getRequestRelationship = (row: any) => {
    const k = partnerRowKey(row);
    return relationshipForRequest[k] ?? row?.relationship ?? 'Mother';
  };

  /** Label beside name on Connection Requests (no default "Mother" for display). */
  const getConnectionRequestRelationLabel = (row: any) => {
    const k = partnerRowKey(row);
    const raw = relationshipForRequest[k] ?? row?.relationship ?? row?.partner_relationship;
    return relationLabelOrParent(raw);
  };

  const setRelationshipForRow = (row: any, value: string) => {
    const k = partnerRowKey(row);
    setRelationshipForRequest((p) => ({ ...p, [k]: value }));
  };

  const handleSendMessage = (row: any) => {
    if (!chatBox?.openChatBox) return;
    const partnerId = row?.student_id;
    if (!partnerId || studentId == null) return;
    const sid = `${studentId}-${partnerId}`;
    chatBox.openChatBox({
      id: partnerId,
      name: catName(row.first_name, row.middle_name, row.last_name) || 'Parent',
      email: row.email,
      type: 'parent',
      partnerId,
      sessionId: sid,
    });
  };

  const closeResendErrorDialog = () => {
    setResendErrorOpen(false);
    setResendErrorMessage('');
  };

  const handleCopyRowInviteLink = async (link: string, rowKey: string) => {
    try {
      await navigator.clipboard.writeText(link);
      setCopiedRowKey(rowKey);
      setTimeout(
        () => setCopiedRowKey((prev) => (prev === rowKey ? null : prev)),
        2000
      );
    } catch {
      toast.error('Could not copy link.');
    }
  };

  const handleResendPending = async (row: any) => {
    const inviteId = row?.id;
    if (inviteId == null || inviteId === '') {
      toast.error('Missing invitation.');
      return;
    }
    const idNum = Number(inviteId);
    if (Number.isNaN(idNum)) {
      toast.error('Invalid invitation.');
      return;
    }
    setWaiting(true);
    try {
      await partnerServices.resendOutgoingPartnerEmailInvite(idNum);
      toast.success('Invitation sent.');
      await loadParentList();
      await loadCurrentParent();
      await loadOutgoingInvites();
      refreshChatList();
    } catch (error: any) {
      const msg =
        error?.response?.data?.message ??
        error?.response?.data?.error ??
        (typeof error?.response?.data === 'string' ? error.response.data : '') ??
        error?.message ??
        '';
      setResendErrorMessage(String(msg).trim() || 'Could not resend invitation.');
      setResendErrorOpen(true);
    } finally {
      setWaiting(false);
    }
  };

  const handleCancelOutboundInvite = async (row: any): Promise<boolean> => {
    const inviteId = row?.id;
    if (inviteId == null || inviteId === '') {
      toast.error('Missing invitation.');
      return false;
    }
    setWaiting(true);
    try {
      await partnerServices.cancelOutgoingPartnerEmailInvite(Number(inviteId));
      toast.success('Invitation cancelled.');
      await loadParentList();
      await loadCurrentParent();
      await loadOutgoingInvites();
      refreshChatList();
      return true;
    } catch (error: any) {
      toast.error(error?.response?.data?.message ?? 'Could not cancel invitation.');
      return false;
    } finally {
      setWaiting(false);
    }
  };

  const openCancelInviteDialog = (row: any) => {
    setCancelInviteRow(row);
    setCancelInviteOpen(true);
  };

  const closeCancelInviteDialog = () => {
    if (waiting) return;
    setCancelInviteOpen(false);
    setCancelInviteRow(null);
  };

  const confirmCancelOutgoingInvite = async () => {
    if (!cancelInviteRow) return;
    const ok = await handleCancelOutboundInvite(cancelInviteRow);
    if (ok) {
      setCancelInviteOpen(false);
      setCancelInviteRow(null);
    }
  };

  const visibility = parentVisibilityCopy(subscriptionInfo);
  const inviteEmailAlreadyListed = isInviteEmailAlreadyListed(inviteformik.values.parent_email);

  return (
    <div className="tab-wrap-panel">
      <div className="">
        <div className="text-left" style={{ paddingBottom: '16px' }}>
          {showStudentParentsSettings && (
            <div
              className={`sp-parent-settings-wrap${parentSettingsLoading ? ' sp-parent-settings-wrap--loading' : ''}`}
            >
              {parentSettingsLoading && (
                <div
                  className="sp-parent-settings-loading"
                  aria-busy="true"
                  aria-live="polite"
                  aria-label="Loading parents settings"
                >
                  <Spinner animation="border" role="status" variant="primary" />
                  <span className="sp-parent-settings-loading__text">
                    Loading parents &amp; invitations…
                  </span>
                </div>
              )}
              <div
                className={`sp-parent-settings${parentSettingsLoading ? ' sp-parent-settings--loading' : ''}`}
              >
              <section className="sp-section" aria-labelledby="sp-connected-heading">
                <div className="sp-section-head">
                  <div className="sp-icon-wrap">
                    <GroupsOutlinedIcon sx={{ fontSize: 20 }} />
                  </div>
                  <h2 id="sp-connected-heading">Connected Parents &amp; Guardians</h2>
                </div>
                {connectedRows.length === 0 ? (
                  <p className="sp-empty-hint">No connected parents yet.</p>
                ) : (
                  connectedRows.map((row) => {
                    const name = catName(row.first_name, row.middle_name, row.last_name) || '—';
                    const initials =
                      `${(row.first_name?.[0] ?? '').toUpperCase()}${(row.last_name?.[0] ?? '').toUpperCase()}` ||
                      '?';
                    const roleLabel = relationLabelOrParent(row.relationship ?? row.partner_relationship);
                    return (
                      <div className="sp-card" key={partnerRowKey(row)}>
                        <div className="sp-person-row">
                          <div className="sp-avatar" aria-hidden>
                            {initials}
                          </div>
                          <div className="sp-person-main">
                            <p className="sp-person-name-line">
                              <span className="sp-person-name sp-person-name--inline">{name}</span>
                              <span className="sp-person-name-dot"> · </span>
                              <span className="sp-person-relation">{roleLabel}</span>
                            </p>
                            <p className="sp-person-email">{row.email}</p>
                          </div>
                          <div className="sp-status-col">
                            <span className="sp-badge sp-badge--connected">
                              <CheckCircleOutlineIcon sx={{ fontSize: 16 }} />
                              Connected
                            </span>
                          </div>
                        </div>
                        <div className="sp-info-box">
                          <h4>{visibility.title}</h4>
                          <p>{visibility.body}</p>
                        </div>
                        {visibility.foot ? <p className="sp-footnote">{visibility.foot}</p> : null}
                        <div className="sp-actions-row">
                          <Button
                            type="button"
                            className="sp-btn-outline"
                            variant="light"
                            onClick={() => handleSendMessage(row)}
                          >
                            <ChatBubbleOutlineIcon sx={{ fontSize: 18 }} />
                            Send Message
                          </Button>
                          {row.email !== currentformik.values.parent_email && (
                            <Button
                              type="button"
                              variant="primary"
                              size="sm"
                              className="btn-setdefault"
                              onClick={() => handleDefaultParent(row)}
                              disabled={
                                waiting && !pendingListAction && currentRow?.student_id === row.student_id
                              }
                            >
                              {waiting &&
                              !pendingListAction &&
                              currentRow &&
                              currentRow.student_id === row.student_id ? (
                                <Spinner size="sm" animation="border" variant="light" />
                              ) : (
                                'Set primary'
                              )}
                            </Button>
                          )}
                          <button
                            type="button"
                            className="sp-link-danger"
                            onClick={() => openRemoveAccessDialog(row)}
                            disabled={waiting && currentRow?.student_id === row.student_id}
                          >
                            {waiting && currentRow?.student_id === row.student_id ? (
                              <Spinner size="sm" animation="border" variant="dark" />
                            ) : (
                              'Remove Access'
                            )}
                          </button>
                        </div>
                      </div>
                    );
                  })
                )}
              </section>

              <section className="sp-section" aria-labelledby="sp-pending-heading">
                <div className="sp-section-head">
                  <h2 id="sp-pending-heading" style={{ margin: 0 }}>
                    Pending Invitations
                  </h2>
                  {outgoingEmailInvites.length > 0 && (
                    <span className="sp-count-badge sp-count-badge--amber">
                      {outgoingEmailInvites.length}
                    </span>
                  )}
                </div>
                {outgoingEmailInvites.length === 0 ? (
                  <p className="sp-empty-hint">No pending invitations.</p>
                ) : (
                  outgoingEmailInvites.map((row) => {
                    const name =
                      catName(row.invitee_first_name ?? '', '', row.invitee_last_name ?? '').trim() ||
                      '—';
                    const initials =
                      `${(row.invitee_first_name?.[0] ?? '').toUpperCase()}${(row.invitee_last_name?.[0] ?? '').toUpperCase()}` ||
                      '?';
                    const relRaw = row.relation ?? row.relationship;
                    const relationBesideName =
                      relRaw != null && String(relRaw).trim() !== ''
                        ? formatRelationshipLabel(String(relRaw))
                        : row.is_current_parent
                        ? 'Invited as current parent'
                        : 'Parent / Guardian';
                    const sent =
                      row.created_at &&
                      `Sent ${new Date(row.created_at).toLocaleDateString(undefined, {
                        month: 'short',
                        day: 'numeric',
                        year: 'numeric',
                      })}`;
                    return (
                      <div className="sp-card" key={outgoingInviteRowKey(row)}>
                        <div className="sp-person-row">
                          <div className="sp-avatar">{initials}</div>
                          <div className="sp-person-main">
                            <p className="sp-person-name-line">
                              <span className="sp-person-name sp-person-name--inline">{name}</span>
                              <span className="sp-person-name-dot"> · </span>
                              <span className="sp-person-relation">{relationBesideName}</span>
                            </p>
                            <p className="sp-person-email">{row.invitee_email}</p>
                          </div>
                          <div className="sp-status-col">
                            {row.is_expired ? (
                              <span className="sp-badge sp-badge--expired">
                                <ScheduleIcon sx={{ fontSize: 16 }} />
                                Expired
                              </span>
                            ) : (
                              <span className="sp-badge sp-badge--pending">
                                <ScheduleIcon sx={{ fontSize: 16 }} />
                                Pending
                              </span>
                            )}  
                            {sent ? <span className="sp-meta-date">{sent}</span> : null}
                          </div>
                        </div>
                        <div className="sp-actions-row">
                          <Button
                            type="button"
                            className="sp-btn-outline"
                            variant="light"
                            onClick={() => handleResendPending(row)}
                            disabled={waiting}
                          >
                            <RefreshIcon sx={{ fontSize: 18 }} />
                            Resend
                          </Button>
                          {row.invite_link && (
                            <Button
                              type="button"
                              className="sp-btn-outline"
                              variant="light"
                              disabled={waiting || row.is_expired}
                              onClick={() =>
                                handleCopyRowInviteLink(
                                  row.invite_link,
                                  String(row.id ?? row.invitee_email ?? 'invite')
                                )
                              }
                            >
                              {copiedRowKey === String(row.id ?? row.invitee_email ?? 'invite') ? (
                                <>
                                  <CheckIcon sx={{ fontSize: 18 }} />
                                  Copied!
                                </>
                              ) : (
                                <>
                                  <ContentCopyIcon sx={{ fontSize: 18 }} />
                                  Copy Invite Link
                                </>
                              )}
                            </Button>
                          )}
                          <button
                            type="button"
                            className="sp-link-danger"
                            onClick={() => openCancelInviteDialog(row)}
                            disabled={waiting}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    );
                  })
                )}
              </section>

              <section className="sp-section" aria-labelledby="sp-requests-heading">
                <div className="sp-section-head">
                  <h2 id="sp-requests-heading" style={{ margin: 0 }}>
                    Connection Requests
                  </h2>
                  {connectionRequestRows.length > 0 && (
                    <span className="sp-count-badge sp-count-badge--blue">
                      {connectionRequestRows.length}
                    </span>
                  )}
                </div>
                <p className="sp-section-sub">
                  A parent or guardian has requested to connect with your GradMap account.
                </p>
                {connectionRequestRows.length === 0 ? (
                  <p className="sp-empty-hint">No connection requests.</p>
                ) : (
                  connectionRequestRows.map((row) => {
                    const name = catName(row.first_name, row.middle_name, row.last_name) || '—';
                    const initials =
                      `${(row.first_name?.[0] ?? '').toUpperCase()}${(row.last_name?.[0] ?? '').toUpperCase()}` ||
                      '?';
                    const rel = getRequestRelationship(row);
                    const relationBesideName = getConnectionRequestRelationLabel(row);
                    return (
                      <div className="sp-card" key={partnerRowKey(row)}>
                        <div className="sp-person-row">
                          <div className="sp-avatar">{initials}</div>
                          <div className="sp-person-main">
                            <p className="sp-person-name-line">
                              <span className="sp-person-name sp-person-name--inline">{name}</span>
                              <span className="sp-person-name-dot"> · </span>
                              <span className="sp-person-relation">{relationBesideName}</span>
                            </p>
                            <p className="sp-person-email">{row.email}</p>
                          </div>
                          <div className="sp-status-col">
                            <span className="sp-badge sp-badge--await">Awaiting Your Approval</span>
                          </div>
                        </div>
                        <div className="sp-request-fields">
                          <label htmlFor={`rel-${partnerRowKey(row)}`}>Relationship</label>
                          <select
                            id={`rel-${partnerRowKey(row)}`}
                            className="sp-relationship-select"
                            value={rel}
                            onChange={(e) => setRelationshipForRow(row, e.target.value)}
                          >
                            {RELATIONSHIP_OPTIONS.filter((o) => o.value !== '').map((o) => (
                              <option key={o.value} value={o.value}>
                                {o.label}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="sp-info-box">
                          <p style={{ margin: 0, fontSize: '0.8125rem', color: '#475569' }}>
                            If you accept, {name.split(' ')[0] || 'this parent'} will be able to see your
                            profile based on your current plan.
                          </p>
                        </div>
                        <div className="sp-actions-row">
                          <Button
                            type="button"
                            variant="primary"
                            className="sp-btn-primary-solid"
                            onClick={() => handleStudentApproval(row)}
                            disabled={
                              waiting &&
                              currentRow?.student_id === row.student_id &&
                              pendingListAction === 'decline'
                            }
                          >
                            {waiting &&
                            pendingListAction === 'approve' &&
                            currentRow?.student_id === row.student_id ? (
                              <Spinner size="sm" animation="border" variant="light" />
                            ) : (
                              <>
                                <CheckIcon sx={{ fontSize: 18 }} />
                                Accept
                              </>
                            )}
                          </Button>
                          <Button
                            type="button"
                            variant="light"
                            className="sp-btn-decline"
                            onClick={() => handleStudentDecline(row)}
                            disabled={
                              waiting &&
                              currentRow?.student_id === row.student_id &&
                              pendingListAction === 'approve'
                            }
                          >
                            {waiting &&
                            pendingListAction === 'decline' &&
                            currentRow?.student_id === row.student_id ? (
                              <Spinner size="sm" animation="border" variant="dark" />
                            ) : (
                              'Decline'
                            )}
                          </Button>
                        </div>
                      </div>
                    );
                  })
                )}
              </section>

              <section
                className="sp-section sp-section--invite"
                id="invite-parent"
                aria-labelledby="sp-invite-heading"
              >
                <div className="sp-card sp-invite-card">
                  <h2 id="sp-invite-heading" className="sp-invite-card__title">
                    Invite a Parent or Guardian
                  </h2>
                  <p className="sp-invite-card__desc">
                    Your parent or guardian will be able to view your GradMap profile and communicate with
                    your counselor. They can also upgrade you to Silver or Gold on your behalf. Upgrading is
                    required for full parent access.
                  </p>
                  <div className="sp-form-grid sp-invite-form sp-invite-form--grid">
                    <div className="sp-invite-form__cell">
                      <TextIconInput
                        icon={<PersonOutlinedIcon />}
                        iconClass="text-primary3"
                        formClass="text-field-dark border-field-dark"
                        mdCol={'12'}
                        label={inviteParentNamesLocked ? 'First Name' : 'First Name*'}
                        name={'parent_first_name'}
                        placeholder="First name"
                        values={inviteformik.values.parent_first_name}
                        disabled={
                          inviteParentNamesLocked ||
                          inviteParentEmailChecking ||
                          inviteEmailAlreadyListed
                        }
                        onChange={inviteformik.handleChange}
                        feedback={
                          inviteformik.touched.parent_first_name &&
                          inviteformik.errors.parent_first_name && (
                            <span className="text-danger">{inviteformik.errors.parent_first_name}</span>
                          )
                        }
                      />
                    </div>
                    <div className="sp-invite-form__cell">
                      <TextIconInput
                        icon={<PersonOutlinedIcon />}
                        iconClass="text-primary3"
                        formClass="text-field-dark border-field-dark"
                        mdCol={'12'}
                        label={inviteParentNamesLocked ? 'Last Name' : 'Last Name*'}
                        name={'parent_last_name'}
                        placeholder="Last name"
                        values={inviteformik.values.parent_last_name}
                        disabled={
                          inviteParentNamesLocked ||
                          inviteParentEmailChecking ||
                          inviteEmailAlreadyListed
                        }
                        onChange={inviteformik.handleChange}
                        feedback={
                          inviteformik.touched.parent_last_name &&
                          inviteformik.errors.parent_last_name && (
                            <span className="text-danger">{inviteformik.errors.parent_last_name}</span>
                          )
                        }
                      />
                    </div>
                    <div className="sp-invite-form__cell">
                      <TextIconInput
                        icon={<MailOutlineIcon />}
                        iconClass="text-primary3"
                        formClass="text-field-dark border-field-dark"
                        mdCol={'12'}
                        label={'Parent Email*'}
                        name={'parent_email'}
                        placeholder="parent@example.com"
                        values={inviteformik.values.parent_email}
                        disabled={inviteParentEmailChecking}
                        onBlur={handleInviteParentEmailBlur}
                        onChange={(e) => {
                          inviteformik.handleChange(e);
                          if (inviteParentNamesLocked) {
                            inviteformik.setFieldValue('parent_first_name', '');
                            inviteformik.setFieldValue('parent_last_name', '');
                            inviteformik.setFieldValue('relationship', '');
                          }
                          setInviteParentNamesLocked(false);
                        }}
                        feedback={
                          inviteEmailAlreadyListed ? (
                            <span id="invite_parent_already_listed" className="text-danger">
                              This parent is already in your invitation list.
                            </span>
                          ) : (
                            inviteformik.touched.parent_email &&
                            inviteformik.errors.parent_email && (
                              <span id="error_email" className="text-danger">
                                {inviteformik.errors.parent_email}
                              </span>
                            )
                          )
                        }
                      />
                      {inviteParentEmailChecking && !inviteEmailAlreadyListed && (
                        <span className="text-secondary fs-13px d-block mt-1">Checking email…</span>
                      )}
                    </div>
                    <div className="sp-invite-form__cell sp-invite-form__cell--relationship">
                      <label className="sp-invite-field-label" htmlFor="invite-relationship">
                        Relationship
                      </label>
                      <select
                        id="invite-relationship"
                        name="relationship"
                        className="sp-relationship-select sp-relationship-select--invite"
                        value={inviteformik.values.relationship}
                        onChange={(e) => {
                          inviteformik.setFieldValue('relationship', e.target.value);
                        }}
                        onBlur={() => inviteformik.setFieldTouched('relationship', true)}
                      >
                        {RELATIONSHIP_OPTIONS.map((o) => (
                          <option key={o.value || 'empty'} value={o.value}>
                            {o.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end mt-4 pt-1">
                    <Button
                      variant="primary"
                      className="sp-btn-invite-send btn-update"
                      onClick={() => inviteformik.handleSubmit()}
                      disabled={
                        inviteParentEmailChecking ||
                        waiting ||
                        inviteEmailAlreadyListed
                      }
                    >
                      {inviteformik.isSubmitting ? (
                        <>
                          <Spinner
                            size="sm"
                            animation="border"
                            variant="light"
                            className="me-2 align-middle"
                            role="status"
                            aria-hidden
                          />
                          <span className="align-middle">Inviting…</span>
                        </>
                      ) : (
                        <>
                          <MailOutlineIcon sx={{ fontSize: 18 }} />
                          Send Invitation
                        </>
                      )}
                    </Button>
                  </div>
                </div>
              </section>
            </div>
            </div>
          )}

          {userRole === USER_ROLE.parent && showSession === 4 && (
            <>
            <div className="">
              <div className="students-header">
                <Typography variant="h4" component="h1" className="students-title">
                  Your Students
                  <span className="students-count">{partnerList.length} students</span>
                </Typography>
                <Typography className="students-description">
                  Manage and track your assigned students' college application progress
                </Typography>
              </div>
            </div>
            </>
          )}
        </div>
        <CounselorInviteAlertDialog open={showAlert} setOpen={setShowAlert}/>
        <Dialog
          open={removeAccessOpen}
          onClose={(_, reason) => {
            if (waiting) return;
            if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
              closeRemoveAccessDialog();
            }
          }}
          aria-labelledby="sp-remove-access-title"
          aria-describedby="sp-remove-access-desc"
        >
          <DialogTitle id="sp-remove-access-title">Remove parent access?</DialogTitle>
          <DialogContent>
            <DialogContentText id="sp-remove-access-desc">
              {removeAccessRow?.email ? (
                <>
                  This will remove access for{' '}
                  <strong>
                    {catName(
                      removeAccessRow.first_name,
                      removeAccessRow.middle_name,
                      removeAccessRow.last_name
                    ) || 'this parent'}
                  </strong>{' '}
                  ({removeAccessRow.email}). You can invite them again later.
                </>
              ) : (
                "This will remove this parent's access. You can invite them again later."
              )}
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2 }}>
            <MuiButton onClick={closeRemoveAccessDialog} disabled={waiting}>
              Back
            </MuiButton>
            <MuiButton
              onClick={confirmRemoveAccess}
              color="error"
              variant="contained"
              disabled={waiting}
            >
              {waiting ? 'Removing…' : 'Remove access'}
            </MuiButton>
          </DialogActions>
        </Dialog>
        <Dialog
          open={cancelInviteOpen}
          onClose={(_, reason) => {
            if (waiting) return;
            if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
              closeCancelInviteDialog();
            }
          }}
          aria-labelledby="cancel-invite-dialog-title"
          aria-describedby="cancel-invite-dialog-desc"
        >
          <DialogTitle id="cancel-invite-dialog-title">Cancel invitation?</DialogTitle>
          <DialogContent>
            <DialogContentText id="cancel-invite-dialog-desc">
              {cancelInviteRow?.invitee_email ? (
                <>
                  This will remove the pending invitation sent to{' '}
                  <strong>{cancelInviteRow.invitee_email}</strong>. You can send a new invitation later if
                  needed.
                </>
              ) : (
                'This will remove the pending invitation. You can send a new invitation later if needed.'
              )}
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2 }}>
            <MuiButton onClick={closeCancelInviteDialog} disabled={waiting}>
              Back
            </MuiButton>
            <MuiButton
              onClick={confirmCancelOutgoingInvite}
              color="error"
              variant="contained"
              disabled={waiting}
            >
              {waiting ? 'Cancelling…' : 'Cancel invitation'}
            </MuiButton>
          </DialogActions>
        </Dialog>
        <Dialog
          open={resendErrorOpen}
          onClose={(_, reason) => {
            if (waiting) return;
            if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
              closeResendErrorDialog();
            }
          }}
          aria-labelledby="resend-invite-error-title"
        >
          <DialogTitle id="resend-invite-error-title">Could not resend</DialogTitle>
          <DialogContent>
            <DialogContentText component="div">{resendErrorMessage}</DialogContentText>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2 }}>
            <MuiButton onClick={closeResendErrorDialog} variant="contained">
              OK
            </MuiButton>
          </DialogActions>
        </Dialog>
        <div id="go-to-bottom"></div> 
      </div>
      <style scoped>{`
#new-counselor .form-control:disabled, 
#new-counselor .form-control[readonly] {
  background-color: #fff;
  opacity: 1;
}
#new-counselor input.text-field-light.border-field-light.form-control:disabled, 
#new-counselor input.text-field-light.border-field-light.form-control[readonly] {
  border-color: #8894AA !important;
  opacity: 1!important;
}

.btn.btn-approval, .btn.btn-remove {
  width: 103px!important;
  height: 44px!important;
  border-radius: 10px !important;
}

.btn.btn-setdefault {
  width: 150px!important;
  height: 44px!important;
  border-radius: 10px !important;
}

.btn.btn-remove.btn-light { 
  color: #0C2551!important;
  border-color: #EFF1F5!important;
  background-color: #EFF1F5!important; 
}

.btn.btn-remove.btn-light:hover { 
  color: #fff!important;
  background-color: #DC3746!important;
  border-color: #DC3746!important;
}

    `}</style>
    </div>
  );
};

export default SettingsParent;
